/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ISharedDataTable } from '../models/interfaces/ISharedDataTable';

@Injectable({
  providedIn: 'root'
})

export class GenericTableData implements ISharedDataTable {
  private readonly tableDataListSource = new BehaviorSubject([]);

  // tslint:disable-next-line: variable-name
  private readonly _refreshNedded = new Subject<void>();
  currentTableDataList = this.tableDataListSource.asObservable();
  tableHeader: any;
  pageSize: number;
  totalItems: number;

  constructor() {
  }

  get refreshNeeded() {
    return this._refreshNedded;
  }

  setTableDataSource(data: string[]) {
    this.tableDataListSource.next(data);
  }

  refreshComponent() {
    this._refreshNedded.next();
  }

  setTableDataList(data: any[]) {
    if (data === null) {
      data = [];
    }
    this.setTableDataSource(data);
  }

  setTotalItems(totalItems: number) {
     this.totalItems = totalItems;
  }

  getTotalItems() {
    return this.totalItems;
  }

  setPageSize(size: number) {
    this.pageSize = size;
  }

  getPageSize(){
    return this.pageSize;
  }

  getTableHeader() {
    return this.tableHeader;
  }

  setTableHeader(data: any) {
    this.tableHeader = data;
  }

  getTableData() {
    return this.tableDataListSource.getValue();
  }
}
